import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import { Container } from 'web-ui-components/lib/global/layout';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import content, { contentPropTypes } from './NewPaymentDateModal.content';
import withContent from '../../containers/withContent';
import { formatDate } from '../../utils/dateUtils';

export const NewPaymentDateModal = ({
	content: { header, description, settlementDateTitle, submissionDateTitle, authoriseButtonLabel, cancelButtonLabel },
	isChaps,
	newSettlementDate,
	newSubmissionDate,
	isPaymentAuthoriseAllowed,
	handleCancelPayment,
	handleAuthorisePayment,
}) => {
	const handleAuthoriseClick = () => {
		handleAuthorisePayment(isPaymentAuthoriseAllowed, isChaps);
	};
	return (
		<Modal isOpen shouldCloseOnOverlayClick={false}>
			<Container className="modal__container u-padding-y-4 u-text-align-center">
				<Icon iconType="ExclamationCircleLarge" size="lg" className="u-margin-x-auto u-margin-bottom-2" />
				<h2>{header}</h2>
				<div>
					<p>{description}</p>
					<p>{`${submissionDateTitle} ${formatDate(newSubmissionDate)}`}</p>
					{!isChaps && <p>{`${settlementDateTitle} ${formatDate(newSettlementDate)}`}</p>}
					<div className="u-margin-bottom-2">
						<Button id="authoriseLaterBtn" onClick={handleAuthoriseClick} width="flush" display="primary">
							{authoriseButtonLabel}
						</Button>
					</div>
					<div>
						<Button id="newPaymentDateCancelBtn" onClick={handleCancelPayment} width="flush">
							{cancelButtonLabel}
						</Button>
					</div>
				</div>
			</Container>
		</Modal>
	);
};

NewPaymentDateModal.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	newSettlementDate: PropTypes.string,
	newSubmissionDate: PropTypes.string,
	handleCancelPayment: PropTypes.func,
	handleAuthorisePayment: PropTypes.func,
	isPaymentAuthoriseAllowed: PropTypes.bool,
	isChaps: PropTypes.bool,
};
export default compose(withContent({ content }))(NewPaymentDateModal);
